import {
  ADD_PLAYLIST_TO_SCREEN,
  ADD_SCREEN_REQUEST,
  ADD_SCREEN_SUCCESS,
  CLIENT_SCREENS_REQUEST,
  CLIENT_SCREENS_SUCCESS,
  COUNT_STATS_OF_SCREEN,
  COUNT_STATS_OF_SCREEN_REQ,
  DELETE_SCREEN,
  FIND_ONE_SCREEN,
  GET_FOLDER_SCREEN_REQ,
  GET_FOLDER_SCREEN_SUCCESS,
  SCREEN_FILTER,
  SCREEN_FLAG_OFF,
  SCREEN_REQUEST,
  SCREEN_REQUEST_FAILED,
  SCREEN_REQUEST_SUCCESS,
  SCREEN_STATUS_ACTIVE,
  SCREEN_STATUS_DEACTIVE,
  UNCHECK_ASSIGNED_SCREEN,
  UPDATE_SCREEN_PAGE_DECREAMENT,
  UPDATE_SCREEN_PAGE_INCREAMENT,
  UPDATE_SCREEN_SUCCESS,
} from "../constant";
const initial = {
  screens: [],
  screen: {},
  screen_stats:{},
  chunkScreens:[],
  screenLimit:25,
  screenPage:1,
  screenLength:0,
  screenLoading: false,
  isScreenAdded: false,
  statsLoading:false,
  activeScreens: 0,
  deactiveScreens: 0,
  isScreenDeleted: false,
  isAdded: false,
  isUnChecked: false,
  mac: '',
  clientScreens:[]
};


export const screenReducer = (state = initial, action) => {
  function findIndex(id){
    let _index= state.screens.findIndex(_screen=>_screen._id==id);
    return _index;
  }
  switch (action.type) {
    case ADD_SCREEN_REQUEST:
      return {
        ...state,
        isScreenAdded: true,
      };
      case COUNT_STATS_OF_SCREEN_REQ:
        return {
          ...state,
          statsLoading:true,
        }
      case COUNT_STATS_OF_SCREEN:
        return {
          ...state,
          statsLoading:false,
          screen_stats:action.payload
        }
    case ADD_SCREEN_SUCCESS:
      let regiScreens = {};
     
      let till_2 = 60 * 1000;
    
      if (Date.now() > +action.payload?.lastActive + till_2) {
        regiScreens = { ...action.payload, onlinesStatus: false };
      } else {
        regiScreens = { ...action.payload, onlinesStatus: true };
      }
      return {
        ...state,
        isScreenAdded: false,
        isAdded: true,
        screens: [...state.screens, regiScreens],
        chunkScreens: [...state.chunkScreens, regiScreens],
        mac: action.payload.mac
      };
      case UPDATE_SCREEN_SUCCESS:
        let updatedEditScreens = {};
        let till_1 = 60 * 1000;
        if (Date.now() > +action.payload?.lastActive + till_1) {
          updatedEditScreens = { ...action.payload, onlinesStatus: false };
        } else {
          updatedEditScreens = { ...action.payload, onlinesStatus: true};
        }
        state.screens[findIndex(action.payload._id)] = { ...updatedEditScreens };
        return {
          ...state,
          screens:state.screens,
          chunkScreens:[...state.chunkScreens,updatedEditScreens]
        }
        case UPDATE_SCREEN_PAGE_INCREAMENT:
          return {
            ...state,
            screenPage:state.screenPage+1
          }
          case UPDATE_SCREEN_PAGE_DECREAMENT:
            return {
              ...state,
              screenPage:state.screenPage-1
            }
        case GET_FOLDER_SCREEN_REQ:
          return {
            ...state,
            screenLoading:true
          }
          case GET_FOLDER_SCREEN_SUCCESS:
           
      let updatedScreens = [];
     
      let till = 60 * 1000;
      //  let distance=now + till;
      action.payload.screens.forEach((row) => {
        //  if(row.isActive){
        if (row?.lastActive !== undefined) {
          console.log(row?.lastActive)
          if (Date.now() > +row?.lastActive + till) {
            updatedScreens.push({ ...row, onlinesStatus: false} );
          } else {
            updatedScreens.push({ ...row, onlinesStatus: true });
           
          }
        }
        else{
          updatedScreens.push({ ...row, onlinesStatus: false });
        }
        // }
      });
            return {
              ...state,
              screenLoading:false,
              screens:updatedScreens,
              chunkScreens:updatedScreens,
              screenLength:action.payload.screenLength
            }
    case SCREEN_REQUEST:
      return {
        ...state,
        screenLoading: true,
      };
    case SCREEN_REQUEST_SUCCESS:
      let newScreen = []
      action.payload.forEach(s => {
        newScreen.push({ ...s, screenAssigned: true })
      })
      return {
        ...state,
        screenLoading: false,
        screens: newScreen,
        activeScreens:state.screens.filter(s=>s.status==true).length,
        deactiveScreens:state.screens.filter(s=>s.status==false).length
      };
    case SCREEN_REQUEST_FAILED:
      return {
        ...state,
        screenLoading: false
      }
    case FIND_ONE_SCREEN:
      return {
        ...state,
        screen: { ...state.screens.find(s => s._id === action.payload), screenAssigned: false }
      }
    case ADD_PLAYLIST_TO_SCREEN:
      // const assingnedScreenIndex = state.screens.findIndex(s => s._id === action.payload._id);
      state.screens[findIndex(action.payload._id)] = { ...action.payload, screenAssigned: false }
      return {
        ...state,
        screens: state.screens,
        isUnChecked: true
      }
    case UNCHECK_ASSIGNED_SCREEN:
      const findUnCheckScreen = findIndex(action.payload)
      state.screens[findUnCheckScreen] = { ...state.screens[findUnCheckScreen], screenAssigned: true }
      return {
        ...state,
        screens: state.screens,
        isUnChecked: true
      }
    case SCREEN_FLAG_OFF:
      return {
        ...state,
        isUnChecked: false,
        isAdded: false,
        isScreenDeleted: false
      }
    case SCREEN_STATUS_ACTIVE:
      // const activeStatusIndex = state.screens.findIndex(s => s._id === action.payload._id)
      state.screens[findIndex(action.payload._id)] = { ...action.payload }
      return {
        ...state,
        screens: state.screens,
        activeScreens:state.screens.filter(s=>s.status==true).length,
      };
    case SCREEN_STATUS_DEACTIVE:
      // const DeactiveStatusIndex = state.screens.findIndex(s => s._id === action.payload._id)
      state.screens[findIndex(action.payload._id)] = { ...action.payload }
      return {
        ...state,
        screens: state.screens,
        deactiveScreens:state.screens.filter(s=>s.status==false).length
      };
    case DELETE_SCREEN:
      return {
        ...state,
        isScreenDeleted: true,
        screens: state.screens.filter(screen => screen._id !== action.payload)
      }
    case CLIENT_SCREENS_REQUEST:
      return {
        ...state,
        screenLoading: true,
      }
    case CLIENT_SCREENS_SUCCESS:
      let newClientScreens = []
      action.payload.forEach(s => {
        newClientScreens.push({ ...s, screenAssigned: true })
      })
      return {
        ...state,
        screenLoading: false,
        clientScreens: newClientScreens,
      };
      case SCREEN_FILTER:
        let _screens;
        // console.log(state.screens)
        // console.log(state.chunkScreens.filter(s=>s.onlinesStatus==false))
        if(action.payload=='all'){
          _screens=state.chunkScreens.filter(s=>s!='');
        }
        else if(action.payload=='offline'){
          _screens=state.chunkScreens.filter(s=>(!s.onlinesStatus));
        }else if(action.payload=='online'){
          _screens=state.chunkScreens.filter(s=>(s.onlinesStatus));
        }
        // else if(action.payload=='pending'){
        //   _screens=state.chunkScreens.filter(s=>s.isLicensed==false)
        // }else{
        //   _screens=state.chunkScreens.filter(s=> Date.now() > new Date(s.licenseTill));
        // }
        // console.log(_screens)
        return {
          ...state,
          screens:_screens
        }
    default:
      return state;
  }
};
